/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {EnqueueCashInRequirementsRequest} from '@cash-web/protos/squareup/cash/moneta/api/v1_0/EnqueueCashInRequirements.pb'
import {EnqueueCashInRequirementsResponse} from '@cash-web/protos/squareup/cash/moneta/api/v1_0/EnqueueCashInRequirements.pb'


export const enqueueCashInRequirements = (request: EnqueueCashInRequirementsRequest, options?: CashRequestOptions) => post<EnqueueCashInRequirementsRequest, EnqueueCashInRequirementsResponse>("/2.0/cash/enqueue-cash-in-requirements", request, {...options, rejectOnError: true })